<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span><br>
    </RouterLink>
    留仙洞站<br>
站点介绍<br>
留仙洞站位于深圳市车站位于南山区西丽镇上, 占用留仙大道中央绿化带、北侧主车道和北侧主辅道间绿化带。留仙洞站呈东西向布置。车站西北侧为深圳职业技术学院，东北侧规划住宅用地，南侧为规划超大规模集成电路园用地。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:12	23:49	5号线	3分钟	5分25秒<br>
黄贝岭	06:17	23:32	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:00	23:49	5号线	4分钟	6分钟<br>
黄贝岭	06:26	23:32	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:00	00:49	5号线	4分钟	6分钟<br>
黄贝岭	06:26	00:32	5号线	4分钟	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
留仙大道南侧、维正·企知道<br><br>
B出入口:<br>
留仙大道北侧、同发路东侧、凯达尔集团中心大厦<br><br>
C出入口:<br>
留仙大道北侧（西）、同发路西侧、高职院西校区<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 留仙洞地铁站<br>
37、235、B708、M176、M429、M539、B855<br><br>
B出入口:<br>
公交站名： 留仙洞地铁站<br>
37、235、B708、B855、M176、M234、M429、M488、M539、高峰专线56、西丽生态公园接驳专线<br><br>
C出入口:<br>
公交站名： 深职院西宿舍区<br>
M197、M393、M429、M488、M539、37、235、B708、B855、M176、M182、高峰专线56、西丽生态公园接驳专线<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


